import React, { useEffect, useMemo, useRef, useState } from 'react';
import styles from './Sections/RequestDetails.module.scss';
import './RequestDetails.scss';
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import {
  requestsSelector,
  setAllRequestData,
  setCurrentRequestId,
} from '../../redux/slicers/requestSlicer';
import { Tab, Tabs } from 'react-bootstrap';
import FullProduct from './Sections/FullProduct';
import Size from './Sections/Size';
import Parts from './Sections/Parts';
import Finishes from './Sections/Finishes';
import Comment from '../../components/Request/Comment';
import {
  apiGetProduct360UploadImages,
  apiGetProp,
  apiGetPropOptimized,
  apiGetRequest,
  apiGetRequestComments,
  apiPostRequestComment,
  apiPostRequestFeedback,
  apiUpdateRequest,
  apiUpdateRequestComment,
} from '../../helpers/api';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import {
  getFormattedTime,
  getNameInitials,
  setDefaultFiles,
  setFilesObject,
  uploadRequestFile,
} from './Sections/helper';
import Notes from './Sections/Notes';
import Attachments from '../../components/Request/Attachments';
import SelectedProp from '../../components/Request/SelectedProp';
import { Image } from '../../common';
import ProductImages from './ProductImages';
import FAVICON from '../../assets/images/favicon.png';
import { REQUESTS_ROUTE } from '../../config/constant/routePathConstant';
import { AccordionCard } from '../../common/AccordionCard';
import Wrapper from '../subscriptionComponents/Wrapper';
import { Breadcrumbs, CommonGrid } from '../../layouts';
import TopContainerV2 from '../../layouts/TopContainerV2';
import { REQUESTS_TYPE_LABEL, REQUEST_STATUS, REQUEST_STATUSES } from '../../constants/constants';
import { usePageTitle } from '../../hooks/usePageTitle';
import downloadjs from 'downloadjs';
import { errorToast, successToast } from '../../helpers/toastHelper';
import { ElipsisTooltip } from '../../common/ElipsisTooltip';
import Loader from '../../components/Loader/Loader';
import React360 from '../../common/React360';
import { fetchAllPages, loadImageAsync } from '../../helpers/apiHelper';
import { SortArrayBySeq, handleToggleScreen } from '../../helpers/jsHelper';
import {
  ThreeSixtyIcon,
  ThreeDRotation,
  TickIcon,
  ImageIcon,
  ModelIcon,
  PDFIcon,
  PlayIconV2,
  FileIcon,
  DownloadV2Icon,
  FullScreenIcon,
} from '../../assets/icons';
import { ModalArea } from '../../common/ModalButtonArea';
import Button from '../../components/Button';
import { REQUEST_EDIT_ROUTE } from '../../constants/routePathConstants';
import CircularProgress from '../../components/CircularProgress/CircularProgress';
import { getUrlExtension } from '../../components/Configurator/utils';
import { useUserContext } from '../../contexts/UserContext';
import { MdOutlineCloseFullscreen } from 'react-icons/md';
import { ProductModel3DSection } from '../NewProductUI/ProductModel3DSection';

function RequestDetails({ hideComments }) {
  const { isGuestUser } = useUserContext();
  const _requestSelector = useSelector(requestsSelector);
  const dispatch = useDispatch();
  const [comments, setComments] = useState([]);
  const [commentsPageInfo, setCommentsPageInfo] = useState({ currentPage: 0 });
  const [createdByList, setCreatedByList] = useState([]);
  const [request, setRequest] = useState();
  const [commentsLoading, setCommentLoading] = useState();
  const [loading, setLoading] = useState(true);
  const [parentCommentId, setParentCommentId] = useState(null);
  const requestStatus = request?.model_request?.status

  const params = useParams();
  const navigate = useNavigate();
  const handleTabChange = (e) => {};

  usePageTitle(request?.name);  

  const getRandomColor = () => `#${Math.floor(Math.random() * 16777215).toString(16)}`;

  const addToUniqueData = (_data) => {
    const _createdBy = createdByList.filter((_item) => _item.id === _data.created_by?.id);

    if (!_createdBy?.length) {
      setCreatedByList([
        ...createdByList,
        { ...(_data.created_by || {}), ...{ background: getRandomColor() } },
      ]);
    }
  };

  const updateRequestStatus = async (status = null) => {
    if (!request?.id || !status || isGuestUser()) return;
    const formData = new FormData();
    formData.append('status', status);
    const response = await apiUpdateRequest(request?.id, formData);
    if(response){
      fetchRequestData?.(request?.id);
    }
  };

  const onCommentEnter = async ({
    _comment,
    textStyle,
    parentId,
    _files,
    isFeedbackChat = false,
  }) => {
    // When status is LIVE_ON_APP, call request-feedback API first before posting comment
    if (requestStatus === REQUEST_STATUSES.LIVE_ON_APP.value) {
      const feedbackFormData = new FormData();
      feedbackFormData.append('model_request', params.id);
      await apiPostRequestFeedback(feedbackFormData);
    }

    const formData = new FormData();
    formData.append('model_request', params.id);
    formData.append('message', _comment);
    if (isFeedbackChat) formData.append('is_feedback_comment', true);
    if (textStyle)
      formData.append(
        'json_data',
        JSON.stringify({ id: textStyle.id, start: textStyle.start, end: textStyle.end })
      );

    if (parentId) {
      formData.append('parent_comment', parentId);
      formData.append('is_reply', true);
    }
    if (parentCommentId) {
      formData.append('parent_comment', parentCommentId);
    }
    let response;

    if (_files?.length) {
      _files.forEach((item) => {
        formData.append('file_name', item.name);
        formData.append('file_size', item.size);
      });

      response = await uploadRequestFile(
        formData,
        _files,
        [],
        null,
        apiPostRequestComment,
        true,
        dispatch,
        _requestSelector
      );
    } else response = await apiPostRequestComment(formData);
     if(requestStatus === REQUEST_STATUSES.FOR_APPROVAL.value){
      updateRequestStatus(REQUEST_STATUSES.FEEDBACK.value)
     }
    if (response.status) {
      if (parentId) {
        const _comment = comments.find((_item) => _item.id === parentId);

        const _replies = _comment?.replies ? _comment?.replies?.filter((_item) => _item) : [{}];
        _comment.replies = [..._replies, response.data];
        _comment.reply_count = _comment.replies?.filter((_reply) => _reply.id)?.length || 0;

        // setComments([...comments.filter((_item) => _item.id !== parentId), _comment]);
        setComments(comments?.map((_item) => (_item.id === parentId ? _comment : _item)));
      } else setComments([...comments, response.data]);

      addToUniqueData(response.data);

      // When LIVE_ON_APP, refresh request details in background so grace_period_info updates
      if (requestStatus === REQUEST_STATUSES.LIVE_ON_APP.value) {
        fetchRequestData(params.id);
      }
    }
  };

  const getReplies = async (commentId, skip) => {
    if (skip) return;
    const _comments = await fetchAllPages((page) => {
      return apiGetRequestComments(
        `model_request=${params.id}&parent_comment=${commentId}&is_reply=true&page=${page}`
      );
    });

    if (_comments?.results?.length) {
      const _comment = comments.find((_item) => _item.id === commentId);

      _comment.replies = _comments?.results;

      setComments(comments?.map((_item) => (_item.id === commentId ? _comment : _item)));

      // setComments([...comments.filter((_item) => _item.id !== commentId), _comment]);
    }
  };

  const hideReplies = (commentId) => {
    const _comment = comments.find((_item) => _item.id === commentId);

    _comment.replies = [];

    setComments(comments?.map((_item) => (_item.id === commentId ? _comment : _item)));

    // setComments([...comments.filter((_item) => _item.id !== commentId), _comment]);
  };

  const fetchRequestData = async (_id = null) => {
    const __id = _id || request?.id;
    if (!__id) return null;
    const _request = await apiGetRequest(__id);
    if (_request) setRequest(_request);
    return _request;
  };

  const getComments = async () => {
    const _comments = await fetchAllPages((page) => {
      return apiGetRequestComments(
        `model_request=${params.id}&is_reply=false&per_page=100&page=${page}`
      );
    });
    setCommentsPageInfo({
      next: _comments?.next_link,
      currentPage: parseInt(_comments?.current_page_number),
      totalPages: _comments?.total_pages,
    });

    if (_comments?.results?.length) {
      setComments([
        ...comments,
        ..._comments?.results?.map((_comment) => {
          return {
            ..._comment,
            images: _comment?.images?.map((_item) => setFilesObject(_item)),
          };
        }),
      ]);
    }

    // Read message functionality is commented

    const last_comment = _comments?.results?.at(-1);

    if (last_comment) {
      const formData = new FormData();
      formData.append('is_read', true);
      formData.append('model_request', params.id);
      await apiUpdateRequestComment(last_comment.id, formData);
      fetchRequestData(params.id);
    }

    _comments?.results.forEach((obj) => {
      addToUniqueData(obj);
    });
  };

  useEffect(() => {
    if (hideComments) return;
    dispatch(setCurrentRequestId(params.id));
  }, []);

  useEffect(async () => {
    if (hideComments) {
      await fetchRequestData(_requestSelector.currentRequestId);
      setLoading(false);
      return;
    }
    const _request = await fetchRequestData(params.id);
    setLoading(false);

    if (!_request || _request?.model_request?.status === REQUEST_STATUSES.DRAFT.value) {
      navigate(REQUESTS_ROUTE);
      return;
    }

    dispatch(setAllRequestData(_request?.json_data));
    setCommentLoading(true);
    await getComments();
    setCommentLoading(false);
  }, []);

  const breadcrumbs = [
    {
      link: REQUESTS_ROUTE,
      label: 'Requests',
    },
    {
      label: request?.name,
    },
  ];

  if (loading && !location.pathname?.includes(REQUEST_EDIT_ROUTE.replace(':id')))
    return <Loader loading backdrop />;

  if (
    request &&
    request?.model_request?.status !== REQUEST_STATUSES.DRAFT.value &&
    !location.pathname?.includes(REQUEST_EDIT_ROUTE.replace(':id'))
  )
    return (
      <CommonGrid
        sticky={false}
        noDataText={''}
        hasData={true}
        topContainer={
          <TopContainerV2 hiddenTab subClassName="mb-3">
            <Breadcrumbs fullWidth list={breadcrumbs} rowClassNames="bg-transparent" />
            <ul className={styles.requestStatus}>
              {Object.keys(REQUEST_STATUS).map((key, index) => {
                const statusIndex = Object.keys(REQUEST_STATUS).findIndex(
                  (k) =>
                    k === request?.model_request?.status ||
                    REQUEST_STATUS[k].otherKey === request?.model_request?.status
                );

                return (
                  <li
                    key={key}
                    className={
                      statusIndex > index ||
                      (statusIndex === -1 && index === 0) ||
                      statusIndex + 1 === Object.keys(REQUEST_STATUS).length
                        ? styles.selected
                        : statusIndex === index
                        ? styles.active
                        : styles.inactive
                    }>
                    <span className={styles.number}>
                      {statusIndex >= index ? <TickIcon /> : index + 1}
                    </span>
                    <span>{REQUEST_STATUS[key].label}</span>
                  </li>
                );
              })}
            </ul>
          </TopContainerV2>
        }>
        <RequestOverview
          request={request}
          refetchData={fetchRequestData}
          commentProps={{
            request,
            hideComments,
            createdByList,
            onCommentEnter,
            comments,
            getReplies,
            hideReplies,
            commentsLoading,
          }}
          setParentCommentId={setParentCommentId}
          parentCommentId={parentCommentId}
        />
      </CommonGrid>
    );

  return _requestSelector.currentRequestId ? (
    <>
      <Loader loading={loading} backdrop />
      <div
        className={cx(
          'd-flex flex-column justify-content-center align-items-start requestDetails "mt-5"',
          styles.wrapper
        )}>
        <h2>{request?.name}</h2>
        <div
          className={cx('d-flex gap-1', styles.bodyWrapper, styles.requestDetailBodyWrapper)}
          style={hideComments ? { height: '70vh' } : {}}>
          <div
            className={cx('mySettings', styles.mySettings, styles.requestDetailWrapper)}
            style={hideComments ? { width: '100%' } : {}}>
            <div className={cx('setting-tabs', styles.requestDetailTab)}>
              <Tabs
                className={cx(styles.requestDetailTopTabs)}
                mountOnEnter
                onSelect={handleTabChange}>
                <Tab eventKey="type" title="Type">
                  <SelectedProp className={styles.noPointerEvents} request={request} />
                </Tab>
                <Tab eventKey="product" title="Images">
                  <ProductImages />
                </Tab>
                <Tab eventKey="size" title="Size">
                  <Size className={styles.noPointerEvents} isReadOnly />
                </Tab>
                <Tab eventKey="parts" title="Parts">
                  <Parts className={styles.noPointerEvents} isReadOnly />
                </Tab>
                <Tab eventKey="finishes" title="Finishes">
                  <Finishes className={styles.noPointerEvents} isReadOnly />
                </Tab>
                <Tab eventKey="notes" title="Notes">
                  <Notes className={styles.noPointerEvents} isReadOnly />
                </Tab>
                {/* <Tab eventKey="attachments" title="Attachments">
                <Attachments
                  className={styles.noPointerEvents}
                  requestId={_requestSelector.currentRequestId}
                />
              </Tab> */}
              </Tabs>
            </div>
          </div>
          {!hideComments ? (
            <div className={styles.commentWrapper}>
              <div className={styles.commentHeader}>
                <div className="d-flex flex-column">
                  <span className={styles.created}>Created</span>
                  <span className={styles.createdDate}>
                    {getFormattedTime(request?.model_request?.created_at)}
                  </span>
                </div>
                <div>
                  {createdByList?.length ? (
                    <div className={styles.usernames}>
                      {createdByList?.map((_comment, index) =>
                        index < 2 ? (
                          <div key={index} className={styles.usernameIcon}>
                            {_comment.is_guest_user ? (
                              <img src={FAVICON} />
                            ) : (
                              getNameInitials(_comment)
                            )}
                          </div>
                        ) : null
                      )}

                      {createdByList?.length > 3 ? (
                        <div className={styles.usernameIcon}>{createdByList?.length - 3}</div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              </div>
              <Comment
                comments={comments}
                createdByList={createdByList}
                onCommentEnter={onCommentEnter}
                getReplies={getReplies}
                requestId={_requestSelector?.currentRequestId}
                hideReplies={hideReplies}
                loading={commentsLoading}
                canComment={true}
              />
            </div>
          ) : null}
        </div>
      </div>
    </>
  ) : null;
}

export default RequestDetails;

const RequestOverview = ({ request, commentProps, refetchData, parentCommentId, setParentCommentId }) => {
  const { isGuestUser } = useUserContext();
  const [dimensions, setDimensions] = useState(null);
  const [files, setFiles] = useState([]);
  const [productInfo, setProductInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModalViewer, setShowModalViewer] = useState(false);
  const [isFeedbackView, setIsFeedbackView] = useState(
    request?.model_request?.status === REQUEST_STATUSES.FOR_APPROVAL.value
  );

  const getDimensions = async () => {
    const _dimensions = await setDefaultFiles(request.id, 'dimensions');
    let dim = [];

    _dimensions?.results?.map((_item) => {
      _item.dimensions.map((i) => dim.push({ ...i, actual_id: _item.id }));
    });
    setDimensions(dim?.[0]);
  };

  const getFiles = async () => {
    if (!request?.id) return;
    await Promise.allSettled([
      setDefaultFiles(request.id, 'productFile'),
      setDefaultFiles(request.id, 'productImages'),
      setDefaultFiles(request.id, 'additionalFiles'),
      setDefaultFiles(request.id, 'referenceImages'),
      setDefaultFiles(request.id, 'detailsImages'),
      setDefaultFiles(request.id, 'dimensionsImages'),
    ]).then((response) => {
      const allFiles = response
        ?.filter((a) => a.status === 'fulfilled')
        ?.map((a) => a.value?.results)
        ?.flat()
        ?.filter(Boolean);
      setFiles(allFiles);
    });
  };

  const fetchProductInfo = async () => {
    if (!request?.product_details?.id) return;
    const api = apiGetPropOptimized || apiGetProp;
    const response = await api(request?.product_details?.id);
    if (response && response?.id) {
      setProductInfo(response);
    }
  };

  const fetchData = async () => {
    if (!request) {
      setLoading(false);
      return;
    }
    await getDimensions();
    setLoading(false);
    await Promise.all([getFiles(), fetchProductInfo()]);
  };

  const updateRequestStatus = async (status = null) => {
    if (!request?.id || !status || isGuestUser()) return;
    const formData = new FormData();
    formData.append('status', status);
    setSubmitLoading(status);
    const response = await apiUpdateRequest(request?.id, formData);
    refetchData?.();
    setSubmitLoading(null);
    if (response?.id) {
      successToast('Request status updated successfully.');
      if (status === REQUEST_STATUSES.FEEDBACK.value) {
        setIsFeedbackView(false);
      }
    } else {
      errorToast('Something went wrong. Please try again later.');
    }
  };

  const haveAnyFeedback = useMemo(() => {
    const comments = commentProps?.comments?.filter((c) => parseInt(c.parent_comment) === parseInt(parentCommentId));
    return comments?.length ? comments?.some((c) => c?.is_feedback_comment) : false;
  }, [commentProps?.comments, parentCommentId]);

  useEffect(fetchData, [request]);

  if (loading) return <Loader loading backdrop />;

  if (!request && !loading) return <Navigate to={REQUESTS_ROUTE} replace />;

  return (
    <>
      <RequestAccordion
        id="REQUEST_DETAILS"
        title={
          <div className="d-flex align-items-center justify-content-between">
            <span>Request details</span>
            <a
              style={{
                fontWeight: 400,
              }}
              className="mx-3 text-decoration-underline"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowModal(true);
              }}>
              View uploaded items
            </a>
          </div>
        }
        open={false}>
        <Wrapper className="mb-0 border-0">
          <div className={styles.requestInfo}>
            <label className={styles.text}>
              Name
              <span>{request?.name}</span>
            </label>
            <label className={styles.text}>
              Type
              <span>
                {request?.request_model_type
                  ? REQUESTS_TYPE_LABEL[request?.request_model_type]
                  : '-'}
              </span>
            </label>

            <label className={styles.text}>
              Dimensions
              <span>
                {dimensions
                  ? `${dimensions?.Width} ${dimensions?.unit?.name} x ${dimensions?.Height} ${dimensions?.unit?.name} x ${dimensions?.Depth} ${dimensions?.unit?.name}`
                  : '-'}
              </span>
            </label>

            <label className={styles.text}>
              Notes
              <span>{request?.additional_notes || '-'}</span>
            </label>
          </div>
        </Wrapper>
      </RequestAccordion>
      <RequestAccordion
        id="REQUEST_ACTIVITY"
        title={
          <div className="d-flex align-items-center justify-content-start gap-2">
            {request?.unread_count > 0 ? (
              <>
                Activity
                <ElipsisTooltip
                  title={`You have ${request?.unread_count} new message${
                    request?.unread_count > 1 ? 's' : ''
                  }.`}
                  alwaysShow={true}>
                  {({ ref, onMouseEnter, onMouseLeave }) => (
                    <div
                      className={styles.unread_count}
                      ref={ref}
                      onMouseEnter={onMouseEnter}
                      onMouseLeave={onMouseLeave}></div>
                  )}
                </ElipsisTooltip>
              </>
            ) : (
              'Activity'
            )}
          </div>
        }
        open={true}
        alwaysOpen={true}>
        <RequestChat
          id="REQUEST_COMMENT"
          {...commentProps}
          viewModelProps={{
            id: productInfo?.id,
            thumbnail: productInfo?.thumbnail,
            onClick: (id) => {
              setShowModalViewer(true);
              setParentCommentId(id);
            },
          }}
        />
      </RequestAccordion>

      <Wrapper className={cx('mb-0', styles.modelViewerWrapper, showModalViewer ? '' : 'd-none')}>
        <div className="mb-4 w-100 d-flex align-items-center justify-content-between">
          <h2 className="mb-0">{request?.name}</h2>
          <button
            onClick={() => {
              setShowModalViewer(false);
              setParentCommentId(null);
            }}
            className={styles.close}></button>
        </div>
        <div
          className={cx(
            styles.modelViewerInnerWrapper
          )}>
          {showModalViewer && productInfo ? (
            <ViewerAndModel showModalViewer={true} productInfo={productInfo} />
          ) : null}
          {/* {request?.model_request?.status === REQUEST_STATUSES.FOR_APPROVAL.value ? ( */}
          {!haveAnyFeedback && isFeedbackView ? (
            <div className={styles.feedbackContainer}>
              <div className={styles.askFeedback}>
                <h3>Your Model is Ready!</h3>
                <p>If there is something that can be improved, please share your feedback.</p>
                <Button
                  size="lg"
                  className="mb-3 w-100"
                  onClick={() => {
                    // setIsFeedbackView(false);
                    updateRequestStatus(REQUEST_STATUSES.FEEDBACK.value);
                  }}
                  color="light"
                  loading={submitLoading === REQUEST_STATUSES.FEEDBACK.value}
                  disabled={isGuestUser()}>
                  Feedback
                </Button>
                <Button
                  size="lg"
                  className="w-100"
                  onClick={() => updateRequestStatus(REQUEST_STATUSES.LIVE_ON_APP.value)}
                  color="dark"
                  loading={submitLoading === REQUEST_STATUSES.LIVE_ON_APP.value}
                  disabled={isGuestUser()}>
                  Mark as approved
                </Button>
              </div>
              <div className={styles.footer}>
                Note: We accept only one round of feedback after model delivery.
              </div>
            </div>
          ) : (
            <RequestChat
              id="REQUEST_FEEDBACK"
              {...commentProps}
              viewModelProps={{
                id: productInfo?.id,
                thumbnail: productInfo?.thumbnail,
                onClick: () => {
                  setShowModalViewer(true);
                  setParentCommentId(null);
                },
              }}
              isFeedbackChat={true}
            />
          )}
        </div>
      </Wrapper>

      <ModalArea
        size="xl"
        showModal={showModal}
        setShowModal={() => setShowModal(false)}
        animation={true}
        centered={true}
        title="Uploaded items"
        headingLeft={true}
        headingClassName="mb-3 lighter"
        className="gray-bg"
        closeBtnStyle={{
          width: '2.5rem',
          height: '2rem',
          background: 'transparent',
          border: 'none',
        }}
        closeBtnIconStyle={{
          width: '2rem',
          height: '2rem',
          background: 'transparent',
        }}
        body={
          files?.length > 0 ? (
            <div
              className="d-grid gap-3"
              style={{
                gridTemplateColumns: 'repeat(auto-fill, minmax(175px, 1fr))',
                height: '100%',
                maxHeight: '600px',
                overflowY: 'auto',
              }}>
              {files.map((file) => (
                <FileCard {...file} key={file.id} />
              ))}
            </div>
          ) : (
            <p className="text-center p-3 mb-0">No files found.</p>
          )
        }
      />
    </>
  );
};

const RequestAccordion = ({ children, ...rest }) => {
  const accordionStyle = {
    background: '#fff',
    borderRadius: '0.25rem',
    overflow: 'hidden',
  };
  return (
    <AccordionCard
      className="px-3 mb-3"
      style={accordionStyle}
      {...rest}
      expandableIconType="ANGLE">
      {children}
    </AccordionCard>
  );
};

const FileCard = ({ id, file, filename = '', thumbnail }) => {
  const [loading, setLoading] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const handleDownload = () => {
    if (!file) {
      errorToast('Unable to download. Please try again later.');
      return;
    }
    setLoading(true);
    return new Promise((resolve, reject) => {
      var x = new XMLHttpRequest();
      x.open('GET', file, true);
      x.responseType = 'blob';
      x.onload = function (e) {
        setLoading(false);
        downloadjs(e.target.response, filename);
        resolve(undefined);
      };
      x.send();
    });
  };

  const Icon = useMemo(() => {
    const extension = getUrlExtension(file);
    switch (extension?.toLowerCase()) {
      case 'pdf':
        return PDFIcon;
      case 'jpg':
      case 'jpeg':
      case 'png':
        return ImageIcon;
      case 'mp4':
        return PlayIconV2;
      case 'xlsx':
      case 'doc':
      case 'docx':
        return FileIcon;
      default:
        return ModelIcon;
    }
  }, [file]);

  return (
    <div id={id} style={{ background: '#fff', borderRadius: '0.25rem' }}>
      <Image
        src={thumbnail}
        ratio={1.3}
        Icon={Icon}
        imgContainerStyle={
          imageLoaded ? {} : { color: 'var(--primary-color)', backgroundColor: '#fff' }
        }
        onLoad={() => setImageLoaded(true)}
      />
      <div
        className="d-flex justify-content-between align-items-center gap-3"
        style={{
          padding: '0.5rem 0.75rem',
        }}>
        <ElipsisTooltip title={filename}>
          {({ ref, onMouseEnter, onMouseLeave }) => (
            <p
              ref={ref}
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
              className={cx('mb-0', styles.text)}>
              <span>{filename}</span>
            </p>
          )}
        </ElipsisTooltip>
        {file ? (
          loading ? (
            <CircularProgress size={14} thickness={1} />
          ) : (
            <DownloadV2Icon
              onClick={handleDownload}
              style={{ cursor: 'pointer', width: 24, flex: '0 0 24px' }}
            />
          )
        ) : null}
      </div>
    </div>
  );
};

const ViewerAndModel = ({ showModalViewer = false, productInfo = null }) => {
  const [type, setType] = useState('VIEWER'); // VIEWER, MODEL
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageZoomMode, setImageZoomMode] = useState(false);
  const [loading, setLoading] = useState('MODEL');
  const [images, setImages] = useState([]);
  const [viewerFullScreen, setViewerFullScreen] = useState(false);
  const modRef = useRef();
  const viewerRef = useRef();

  const { product_file, is_windows_and_doors, product_file_window_door, is_prop_group } =
    productInfo || {};
  const hasModelFile = useMemo(
    () => (is_prop_group ? null : is_windows_and_doors ? product_file_window_door : product_file),
    [is_prop_group, is_windows_and_doors, product_file, product_file_window_door, productInfo]
  );

  useEffect(() => {
    imageZoomMode && setImageZoomMode(false);
  }, [type, viewerFullScreen]);

  useEffect(() => {
    viewerRef?.current?.addEventListener('fullscreenchange', handleExitViewerFullScreen);
    viewerRef?.current?.addEventListener('webkitfullscreenchange', handleExitViewerFullScreen);

    return () => {
      viewerRef?.current?.removeEventListener('fullscreenchange', handleExitViewerFullScreen);
      viewerRef?.current?.removeEventListener('webkitfullscreenchange', handleExitViewerFullScreen);
    };
  }, [viewerRef.current]);

  const handleExitViewerFullScreen = () => {
    if (!document.fullscreenElement && !document.webkitFullscreenElement)
      setViewerFullScreen(false);
  };

  const fetchProductImages = async () => {
    if (!showModalViewer || !productInfo?.id) return;
    const imageResponse = await apiGetProduct360UploadImages(productInfo?.id);
    if (imageResponse && imageResponse?.results?.length >= 24) {
      const imgList = imageResponse?.results;
      let loadedImages = [];
      await Promise.allSettled(
        imgList.map(async (image) => {
          const res = await loadImageAsync(image.image_file);
          if (res) {
            loadedImages.push(image);
          }
        })
      );
      setLoading(null);
      setImages(SortArrayBySeq(loadedImages, 'sequence_number'));
    } else {
      // setType(productInfo?.glb_file && productInfo?.usdz_file ? 'MODEL' : 'VIEWER');
      setType(hasModelFile ? 'MODEL' : 'VIEWER');
    }
    setLoading(null);
  };

  useEffect(() => {
    if (!productInfo || !showModalViewer) return;
    if (hasModelFile) {
      // if (productInfo?.glb_file && productInfo?.usdz_file) {
      setLoading('MODEL');
      // modRef?.current?.addEventListener('load', () => {
      //   setLoading(null);
      // });
    } else {
      setType('VIEWER');
    }
    fetchProductImages();

    // return () => {
    //   modRef?.current?.removeEventListener('load', () => {
    //     setLoading(null);
    //   });
    // };
  }, [showModalViewer, hasModelFile, productInfo]);

  const modelViewer = () => {
    return (
      <model-viewer
        src={productInfo?.glb_file + '#canonicalWebPageURL=https://imagine.io'}
        ios-src={
          productInfo?.usdz_file
            ? productInfo?.usdz_file + '#canonicalWebPageURL=https://imagine.io'
            : ''
        }
        camera-controls
        shadow-intensity="1"
        touch-action="pan-y"
        ref={modRef}
        style={{ width: '100%', height: '500px', background: 'transparent' }}></model-viewer>
    );
  };

  const ModelViewComponent = useMemo(
    () => (productInfo?.glb_file && productInfo?.usdz_file ? modelViewer() : null),
    [productInfo?.glb_file, productInfo?.usdz_file]
  );

  const handleDownloadCurrentImage = () => {
    const imageElem = document.createElement('img');
    imageElem.src = images[window.$currentImageIndex]?.image_file || images?.[0]?.image_file;
    const imageName = `${window.$currentImageIndex || 0}.jpeg`;
    const anchorTag = document.createElement('a');
    anchorTag.setAttribute('href', imageElem.src);
    anchorTag.setAttribute('download', imageName);
    anchorTag.click();
  };

  return (
    <div
      className={cx(
        'product-details mx-auto bg-white p-0',
        !productInfo?.id && !loading ? 'd-flex align-items-center justify-content-center' : ''
      )}
      ref={viewerRef}>
      {loading !== null ? (
        <Loader loading={true} size={32} thickness={4} position="absolute" />
      ) : null}
      {!productInfo?.id && !loading ? (
        <p className="text-center p-3">No product is linked with this request.</p>
      ) : (
        <>
          {/* productInfo?.glb_file && productInfo?.usdz_file */}
          <div className={styles.viewerSwitcher}>
            <span
              className={viewerFullScreen ? 'fullscreen-icon' : 'fullscreen-icon-request'}
              onClick={() => handleToggleScreen(viewerRef.current, setViewerFullScreen)}>
              {viewerFullScreen ? <MdOutlineCloseFullscreen /> : <FullScreenIcon />}
            </span>
            {hasModelFile && images.length >= 24 ? (
              <>
                <span
                  className={type === 'VIEWER' ? styles.selected : ''}
                  onClick={() => setType('VIEWER')}>
                  <ThreeSixtyIcon />
                </span>
                <span
                  className={type === 'MODEL' ? styles.selected : ''}
                  onClick={() => setType('MODEL')}>
                  <ThreeDRotation />
                </span>
              </>
            ) : null}
          </div>
          <div
            className={cx(
              'product-image h-100 w-100 bg-white text-center',
              type !== 'VIEWER' ? 'd-none' : '',
              viewerFullScreen ? 'request-details-page' : ''
            )}
            style={{ width: 'fit-content' }}>
            {images?.length >= 24 ? (
              <>
                <React360
                  numImages={images?.length}
                  productImages={images?.map((img) => img?.image_file) || []}
                  setImageLoaded={setImageLoaded}
                  setImageZoomMode={setImageZoomMode}
                  isImageZoomEnabled
                  imageZoomMode={imageZoomMode}
                  imgStyle={!imageZoomMode ? {maxHeight:"100%"} : {}}
                  isFullscreen={viewerFullScreen}
                />
                {imageLoaded ? (
                  <span className="drag-rotate">
                    {imageZoomMode ? (
                      <span>Double click to reset zoom or scroll to zoom in or out.</span>
                    ) : (
                      <>
                        {' '}
                        <ThreeSixtyIcon />{' '}
                        <span>Click and drag to rotate or double click to zoom in</span>
                      </>
                    )}
                    <span className="download-icon" onClick={handleDownloadCurrentImage}>
                      <DownloadV2Icon />
                    </span>
                  </span>
                ) : null}
              </>
            ) : (
              <Image
                src={productInfo?.thumbnail}
                onLoad={setImageLoaded}
                alt={imageLoaded ? '' : 'Unable to load product image.'}
              />
            )}
          </div>

          <div className={cx(type !== 'MODEL' ? 'd-none' : '', 'product-image h-100 bg-white')}>
            {/* {ModelViewComponent} */}
            <ProductModel3DSection product={productInfo} className={styles.modelHeight} />

            <span className="drag-rotate">
              <span>Drag to rotate. Scroll to zoom in and out.</span>
            </span>
            {/* productInfo?.glb_file && productInfo?.usdz_file */}
            {hasModelFile ? null : (
              <p className="text-center p-3 mb-0">No model file is available for this product.</p>
            )}
          </div>
        </>
      )}
    </div>
  );
};

const RequestChat = ({
  id,
  request,
  hideComments,
  createdByList,
  onCommentEnter,
  comments,
  getReplies,
  hideReplies,
  commentsLoading,
  viewModelProps = null,
  isFeedbackChat = false,
}) => {
  const ViewModelCard = (props) => {
    if (!viewModelProps?.id) return null;
    const commentId = props?.id;

    return (
      <div
        className="d-flex gap-2 flex-column w-100"
        style={{ maxWidth: '164px', borderRadius: '0.25rem' }}>
        <Image src={viewModelProps?.thumbnail} placeholderWhileLoading ratio={1.3} />
        <Button
          size="lg"
          onClick={() => {
            viewModelProps?.onClick?.(commentId);
          }}
          color="light">
          View model
        </Button>
      </div>
    );
  };

  const canComment =
    request?.model_request?.status !== REQUEST_STATUSES.LIVE_ON_APP.value ||
    request?.is_comment_allowed_user;
  const disableComments = !request?.is_comment_allowed_user;

  const _onCommentEnter = (e) => {
    if (disableComments || commentsLoading) return;
    onCommentEnter(e);
  };

  const feedbackComments = useMemo(() => {
    if (isFeedbackChat) {
      const index = comments?.findIndex((c) => c?.is_feedback_comment);
      if (index !== -1) {
        return comments?.slice(index);
      }
      return [];
    }
    return comments;
  }, [isFeedbackChat, comments]);

  // --- Grace period info from API response ---
  const gracePeriodInfo = request?.grace_period_info;
  const isLiveOnApp = request?.model_request?.status === REQUEST_STATUSES.LIVE_ON_APP.value;
  const isGracePeriodActive = gracePeriodInfo?.is_grace_period_active ?? false;
  const canRequestFeedback = gracePeriodInfo?.can_request_feedback ?? false;

  // Banner message from API
  const feedbackBannerMessage = useMemo(() => {
    if (!isLiveOnApp) return '';
    // Show the info message from API when grace period is active
    if (isGracePeriodActive && gracePeriodInfo?.info_message) {
      return gracePeriodInfo.info_message;
    }
    return '';
  }, [isLiveOnApp, isGracePeriodActive, gracePeriodInfo?.info_message]);

  // Feedback window is closed when:
  // 1. Status is LIVE_ON_APP AND grace period is active but can_request_feedback is false
  // 2. Status is LIVE_ON_APP AND grace period is NOT active (expired)
  const feedbackWindowClosed = useMemo(() => {
    if (!isLiveOnApp) return false;
    // Grace period expired (not active) → window closed
    if (!isGracePeriodActive) return true;
    // Grace period active but cannot request feedback → window closed
    if (!canRequestFeedback) return true;
    return false;
  }, [isLiveOnApp, isGracePeriodActive, canRequestFeedback]);

  const handleRequestFeedback = async () => {
    if (!request?.id) return;
    const formData = new FormData();
    formData.append('model_request', request.id);
    await apiPostRequestFeedback(formData);
  };

  if (!request || hideComments) return null;

  return (
    <Comment
      id={id}
      designV2={true}
      comments={feedbackComments}
      createdByList={createdByList}
      onCommentEnter={_onCommentEnter}
      getReplies={getReplies}
      requestId={request?.id}
      hideReplies={hideReplies}
      loading={commentsLoading}
      canComment={canComment || request?.is_comment_allowed_user || feedbackWindowClosed}
      hideCommentBy={true}
      hideReplyOption={true}
      showDateInStatus={true}
      afterCommentComponent={(props) => <ViewModelCard {...props} />}
      isFeedbackChat={isFeedbackChat}
      goToLastComment={true}
      disableComments={disableComments}
      feedbackBannerMessage={!feedbackWindowClosed ? feedbackBannerMessage : null}
      isGracePeriodExpired={isLiveOnApp && !isGracePeriodActive}
      onRequestFeedback={feedbackWindowClosed ? handleRequestFeedback : null}
      feedbackWindowClosed={feedbackWindowClosed}
    />
  );
};
